// for refactor change ref into Nuxt useState
import { ref } from "vue";

const elementsHidingScroll = ref(0);
const savedScrollPosition = ref(0);
const isScrollDisabled = ref(false);

export default () => {
  const toggleStyles = () => {
    if (elementsHidingScroll.value > 0 && !isScrollDisabled.value) {
      isScrollDisabled.value = true;

      savedScrollPosition.value = window.pageYOffset;

      document.body.style.top = `-${savedScrollPosition.value}px`;
      document.body.style.position = "fixed";
      document.body.style.overflow = "hidden";
      document.body.style.width = "100%";

      document.documentElement.style.scrollBehavior = "auto";
    } else if (elementsHidingScroll.value < 1 && isScrollDisabled.value) {
      ["top", "position", "overflow", "width"].forEach((property) => {
        document.body.style.removeProperty(property);
      });

      window.scrollTo(0, savedScrollPosition.value);

      document.documentElement.style.removeProperty("scroll-behavior");

      isScrollDisabled.value = false;
    }
  };

  const hideScroll = () => {
    // if process.server was true then return
    elementsHidingScroll.value = elementsHidingScroll.value + 1;

    toggleStyles();
  };

  const showScroll = () => {
    // if process.server was true then return
    elementsHidingScroll.value = elementsHidingScroll.value - 1;

    toggleStyles();
  };

  return {
    hideScroll,
    showScroll,
  };
};
